var _span;
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import Button from './Button';
import SafeAnchor from './SafeAnchor';
import { bsClass as setBsClass } from './utils/bootstrapUtils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
class DropdownToggle extends React.Component {
  render() {
    const {
      noCaret,
      open,
      useAnchor,
      bsClass,
      className,
      children,
      ...props
    } = this.props;
    const Component = useAnchor ? SafeAnchor : Button;
    const useCaret = !noCaret;

    // This intentionally forwards bsSize and bsStyle (if set) to the
    // underlying component, to allow it to render size and style variants.

    // FIXME: Should this really fall back to `title` as children?

    return /*#__PURE__*/_jsxs(Component, {
      ...props,
      role: "button",
      className: clsx(className, bsClass),
      "aria-haspopup": true,
      "aria-expanded": open,
      children: [children || props.title, useCaret && ' ', useCaret && (_span || (_span = /*#__PURE__*/_jsx("span", {
        className: "caret"
      })))]
    });
  }
}
DropdownToggle.defaultProps = {
  open: false,
  useAnchor: false
};
export default setBsClass('dropdown-toggle', DropdownToggle);